/**
 * Aviso del editor con los elementos y filtros que usan columnas que ya no están en su fuente
 * (por ejemplo, tras reemplazar la hoja). Cada fila lleva al elemento para corregirlo.
 */
import React, { useState } from 'react';
import { ink } from '../studioUi';

const MissingFieldsBanner = ({ items = [], onGoTo }) => {
    const [open, setOpen] = useState(true);
    if (!items.length) return null;
    const fields = new Set(items.flatMap(item => item.fields));
    const summary = `${fields.size} ${fields.size === 1 ? 'campo sin equivalente afecta' : 'campos sin equivalente afectan'} `
        + `${items.length} ${items.length === 1 ? 'elemento' : 'elementos'}`;
    return (
        <div style={ui.box} role="status">
            <div style={ui.head}>
                <strong style={ui.title}>{summary}</strong>
                <button type="button" style={ui.toggle} onClick={() => setOpen(v => !v)}>{open ? 'Ocultar' : 'Ver detalle'}</button>
            </div>
            {open && (
                <ul style={ui.list}>
                    {items.map(item => (
                        <li key={`${item.kind}-${item.id}`} style={ui.row}>
                            <span style={ui.text}>
                                {`${item.pageName} → ${item.label}`}
                                <span style={ui.fields}>{` · ${item.fields.join(', ')}`}</span>
                            </span>
                            <button type="button" style={ui.go} onClick={() => onGoTo(item.pageId, item.id, item.kind)}>Ir al elemento</button>
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

const ui = {
    box: { margin: '0 0 12px', padding: '10px 14px', borderRadius: 12, borderWidth: 1, borderStyle: 'solid', borderColor: '#f6c7c3', backgroundColor: '#fff6f5' },
    head: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 },
    title: { fontSize: '0.86rem', color: ink.danger },
    toggle: { appearance: 'none', borderWidth: 0, backgroundColor: 'transparent', color: ink.accent, fontSize: '0.78rem', cursor: 'pointer' },
    list: { listStyle: 'none', margin: '8px 0 0', padding: 0, display: 'flex', flexDirection: 'column', gap: 6 },
    row: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 10, fontSize: '0.82rem', color: ink.text },
    text: { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' },
    fields: { color: ink.muted },
    go: { appearance: 'none', flexShrink: 0, padding: '3px 10px', borderRadius: 999, borderWidth: 1, borderStyle: 'solid', borderColor: ink.lineStrong, backgroundColor: ink.surface, color: ink.accentText, fontSize: '0.75rem', cursor: 'pointer' },
};

export default MissingFieldsBanner;
